import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    multiparts: [],
    fetchingMultiparts: false,
    isTruncated: false,
    nextKeyMarker: null,
    nextUploadIdMarker: null,
    showMultiparts: false,
    gettingMultipart: false,
    multipart: [],
    completingMultipart: false,
  },
  mutations: {
    SET_MULTIPARTS(state, data) {
      state.multiparts = data.multipartUploads
      state.nextKeyMarker = data.nextKeyMarker
      state.nextUploadIdMarker = data.nextUploadIdMarker
      state.isTruncated = data.isTruncated
    },
    ADD_MULTIPARTS(state, data) {
      state.multiparts = [...state.multiparts, ...data.multipartUploads]
      state.nextKeyMarker = data.nextKeyMarker
      state.isTruncated = data.isTruncated
    },
    SET_FETCHING_MULTIPARTS(state, value) {
      state.fetchingMultiparts = value
    },
    SET_SHOW_MULTIPARTS(state, value) {
      state.showMultiparts = value
    },
    SET_GETTING_MULTIPART(state, value) {
      state.gettingMultipart = value
    },
    GET_MULTIPART(state, value) {
      state.multipart = value
    },
    SET_COMPLETING_MULTIPART(state, value) {
      state.completingMultipart = value
    },
  },
  actions: {
    // eslint-disable-next-line no-empty-pattern
    initiateMultipart({}, payload) {
      return new Promise((resolve, reject) => {
        api('storage').post(`/v1/projects/${payload.projectId || projectId()}/buckets/${payload.bucketName}/uploads?key=${payload.key}&isPrivate=${payload.private}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    completeMultipartUpload({ commit }, payload) {
      commit('SET_COMPLETING_MULTIPART', true)
      return new Promise((resolve, reject) => {
        api('storage').put(`/v1/projects/${payload.projectId || projectId()}/buckets/${payload.bucketName}/uploads/${payload.id}`, payload.object)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => { commit('SET_COMPLETING_MULTIPART', false) })
      })
    },
    fetchMultiparts({ commit }, payload) {
      let url = `/v1/projects/${projectId()}/buckets/${payload.bucketName}/uploads?MaxUploads=${payload.maxUploads}`
      if (payload.nextKeyMarker) {
        url += `&KeyMarker=${payload.nextKeyMarker}&UploadIdMarker=${payload.nextUploadIdMarker}`
      }
      commit('SET_FETCHING_MULTIPARTS', true)
      return new Promise((resolve, reject) => {
        api('storage').get(url)
          .then(response => {
            if (payload.nextKeyMarker) {
              commit('ADD_MULTIPARTS', response.data.result)
            } else {
              commit('SET_MULTIPARTS', response.data.result)
            }
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_MULTIPARTS', false) })
      })
    },
    getMultipart({ commit }, payload) {
      commit('SET_GETTING_MULTIPART', true)
      return new Promise((resolve, reject) => {
        api('storage').get(`/v1/projects/${projectId()}/buckets/${payload.bucketName}/uploads/${payload.uploadId}?key=${payload.key}`)
          .then(response => {
            commit('GET_MULTIPART', response.data.result)
            resolve(response)
          })
          .catch(error => {
            commit('GET_MULTIPART', [])
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_MULTIPART', false) })
      })
    },
  },
}
